import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@sopranodesign/pulse-components';

import Bubble from './Bubble';
import ActionButton from './ActionButton/index';

const Action = ({
  content,
  handleButtonClick,
  handleButtonLocationClick,
  direction,
  hasHadReply,
  ...props
}) => (
  <Flex fat="true" right={direction === 'recievedMessage'}>
    <Bubble direction={direction} {...props}>
      <span>{content.text}</span>
      <Flex col mt ySpaceSm fat>
        {content.responses.map((response, key) => (
          <ActionButton
            key={key}
            direction={direction}
            response={response}
            handleButtonClick={response.type === 'location' ? handleButtonLocationClick : handleButtonClick}
            hasHadReply={hasHadReply}
          />
        ))}
      </Flex>
    </Bubble>
  </Flex>
);

Action.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired,
    responses: PropTypes.array.isRequired
  }).isRequired,
  direction: Bubble.propTypes.direction,
  handleButtonClick: PropTypes.func.isRequired,
  handleButtonLocationClick: PropTypes.func.isRequired,
  hasHadReply: PropTypes.bool
};

export default Action;
